import { T } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { KomponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-dto';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-komponent-list',
    templateUrl: './komponent-list.component.html',
    styleUrls: ['./komponent-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KomponentListComponent implements OnInit {
  private _komponenter: KomponentDto[];
  @Input() set komponenter(komponenter: KomponentDto[]) {
    this._komponenter = komponenter;
    if (komponenter) {
      this.updateTableView();
    }
  }

  get komponenter(): KomponentDto[] {
    return this._komponenter;
  }

  @Output() editKomponent: EventEmitter<KomponentDto> = new EventEmitter();
  @Output() addKomponent: EventEmitter<void> = new EventEmitter();
  @Output() deleteKomponent: EventEmitter<KomponentDto> = new EventEmitter();

  canWrite: boolean = false;

  constructor(private auth: AuthService) {
    this.canWrite = this.auth.canWrite;
  }

  ngOnInit(): void {}

  getGarantiEndDate(instaDate: Date, garanti: number): Date {
    return moment(instaDate).add(garanti, 'month').subtract(1, 'day').toDate();
  }

  activeColumns: string[] = ['type', 'model', 'serienummer', 'installationDate', 'garantiPeriode', 'rowActions'];
  dataSource = new BehaviorSubject<KomponentDto[]>([]);

  updateTableView() {
    this.dataSource.next(this.komponenter);
  }
}
